import { useDispatch, useSelector } from "react-redux";

import { Link } from "react-router-dom";
import { renderStatus } from "../../../../Utils/CommonUtils";
import { editModal, openModal, updateRendererFormState } from "../../../../slices/common/reducer";
import { setOrgRelationshipEditID } from "../../../../slices/org/organizationRelationshipSlice";
import { EditListIcon } from "../../../../assets/images/svg/svg";

const useOrganizationRelationshipColumn = () => {
  const dispatch = useDispatch();
  const organizationRelationshipColumns = [
    {
      header: "Code",
      accessorKey: "code",
      cell: (props) => (
        <Link
          className="table-drilling-link"
          // to={`/org/org/update/${props.row.original.entityid}`}
        >
          {props?.getValue() ? props?.getValue() : "-"}
        </Link>
      ),
      size: 200,
    },
    {
      header: "Name",
      accessorKey: "name",
      cell: (props) => (props?.getValue() ? props?.getValue() : "-"),
      size: 200,
    },
    {
      header: "Description",
      accessorKey: "description",
      cell: (props) => (props?.getValue() ? props?.getValue() : "-"),
      size: 200,
    },
    {
      header: "Status",
      accessorKey: "status",
      cell: (props) =>
        props?.getValue() ? renderStatus(props?.getValue()) : "-",
      size: 160,
    },
    {
      header: "Action",
      accessorKey: "action",
      cell: (props) => (
        <div className="action-icons text-center">
          <span
            // className="btn btn-sm btn-soft-info edit-list"
            onClick={() => {
              dispatch(openModal(true));
              dispatch(editModal(true));
              dispatch(updateRendererFormState(props?.row?.original));
              dispatch(setOrgRelationshipEditID(props?.row?.original?.id));
            }}
          >
            <EditListIcon />
          </span>
        </div>
      ),
      meta: { align: "center" },
      size: 100,
    },
  ];

  return { organizationRelationshipColumns };
};

export default useOrganizationRelationshipColumn;
